require('./bootstrap');

// magnetic buttons function

// enable this function on a button by setting the 'data-magnetic'-attribute on it
// if z-index matters, set also the class: 'preserve-3d' on it (transform-style: preserve-3d)

const magneticButtons = document.querySelectorAll('[data-magnetic]');

magneticButtons.forEach((btn) => {

    btn.addEventListener("mousemove", function(e) {

    const position = btn.getBoundingClientRect();
    const x = e.pageX - position.left - position.width / 2;
    const y = e.pageY - position.top - position.height / 2 - window.pageYOffset;

    btn.style.transform = "translate(" + x * 0.006 + "rem, " + y * 0.012 + "rem)"; // button
    btn.children[0].style.transform = "translate(" + x * 0.003 + "rem, " + y * 0.006 + "rem)"; // button-arrow
    btn.children[1].style.transform = "translate(" + x * 0.003 + "rem, " + y * 0.006 + "rem)"; // button-text
    btn.children[3].style.transform = "translate3d(" + x * -0.006 + "rem, " + y * -0.012 + "rem, " + "-1rem)"; // wave-line
    });
});

magneticButtons.forEach((btn) => {

    btn.addEventListener("mouseout", function(e ){

    btn.style.transform = "translate(0rem, 0rem)"; // button
    btn.children[0].style.transform = "translate(0rem, 0rem)"; // button-arrow
    btn.children[1].style.transform = "translate(0rem, 0rem)"; // button-text
    btn.children[3].style.transform = "translate3d(0rem, 0rem, -1rem)"; // wave-line
    });
});